import { render, staticRenderFns } from "./indata.vue?vue&type=template&id=ace74738&scoped=true"
import script from "./indata.vue?vue&type=script&lang=js"
export * from "./indata.vue?vue&type=script&lang=js"
import style0 from "./indata.vue?vue&type=style&index=0&id=ace74738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace74738",
  null
  
)

export default component.exports